module.exports = __webpack_public_path__ + "static/img/software16.30fb0d1d.png";